import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm$baseModel;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: {
      warehousePopin: _vm.mode == "popin"
    }
  }, [this.readOnly ? _c("div", [_c("div", [_vm._v(_vm._s((_vm$baseModel = _vm.baseModel) === null || _vm$baseModel === void 0 ? void 0 : _vm$baseModel.name))]), _c("address-warehouse", {
    ref: "address",
    attrs: {
      baseModel: _vm.baseModel.address,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: _vm.readOnly
    }
  })], 1) : _c("div", [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name",
      placeholder: "Warehouse name",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.baseModel.name,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "name", $$v);
      },
      expression: "baseModel.name"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Mail",
      placeholder: "mailwarehouse@domain.com",
      rules: [_vm.formRules.mustBeEmail],
      "hide-details": "auto"
    },
    model: {
      value: _vm.baseModel.mail,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "mail", $$v);
      },
      expression: "baseModel.mail"
    }
  }), _c("div", {
    staticClass: "d-flex align-center text-smaller"
  }, [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.baseModel.isPreventInvoice,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "isPreventInvoice", $$v);
      },
      expression: "baseModel.isPreventInvoice"
    }
  }), !_vm.baseModel.isPreventInvoice ? _c("span", [_vm._v(" By default, order with this departure will generate a C&M invoice ")]) : _c("span", [_vm._v("By default, order with this departure will NOT generate a C&M invoice")])], 1), _c("div", {
    staticClass: "d-flex align-center text-smaller"
  }, [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.baseModel.isInboundCompatible,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "isInboundCompatible", $$v);
      },
      expression: "baseModel.isInboundCompatible"
    }
  }), !_vm.baseModel.isInboundCompatible ? _c("span", [_vm._v(" This warehouse can't be chosen as an inbound destination ")]) : _c("span", [_vm._v("This warehouse can be chosen as an inbound destination")])], 1), _c("StockReservation", {
    key: "reservation-" + _vm.boolRenderReservation,
    ref: "reservation",
    attrs: {
      form: {
        stockReservationType: _vm.baseModel.default_stock_reservation_type,
        stockReservationUserId: _vm.baseModel.default_stock_reservation_user_id,
        stockReservationConsultantId: _vm.baseModel.default_stock_reservation_consultant_id
      },
      isPrefixedWithDefault: true
    },
    on: {
      change: _vm.updateStockReservation
    }
  }), _c("address-warehouse", {
    ref: "address",
    attrs: {
      baseModel: _vm.baseModel.address,
      listCountries: _vm.listCountriesFiltered,
      listStates: _vm.listStates,
      readOnly: _vm.readOnly,
      typeDisplayError: "rules"
    }
  }), _vm.baseModel.id_warehouse && _vm.baseModel.defaultDepartures.length ? _c(VCombobox, {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "hide-details": "auto",
      label: "Default consolidation/departure for",
      chips: "",
      multiple: "",
      readonly: "",
      "append-icon": ""
    },
    model: {
      value: _vm.getContinentsFullNames,
      callback: function callback($$v) {
        _vm.getContinentsFullNames = $$v;
      },
      expression: "getContinentsFullNames"
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "mt-2"
  }, [_c(VExpansionPanels, {
    attrs: {
      value: 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c("div", [_c("div", {
    staticClass: "text-bold"
  }, [_vm._v("Available destinations")]), _c("div", {
    staticClass: "flex flex-column items-start text-smaller mt-1"
  }, [_c("div", [_vm._v("used for default intended countries of stocks,")]), _c("div", [_vm._v(" used for storage location filter on wines list, based on the final customer's delivery address, especially if there is a state-level detail. ")])])])]), _c(VExpansionPanelContent, [_c("ul", {
    staticClass: "rm-margin"
  }, _vm._l(_vm.baseModel.availableDestinations, function (item) {
    var _item$stateId;
    return _c("li", {
      key: "destination-".concat(item.countryId, "-").concat((_item$stateId = item.stateId) !== null && _item$stateId !== void 0 ? _item$stateId : 0),
      staticClass: "text-smaller py-1"
    }, [_c("div", {
      staticClass: "flex items-center gap-4"
    }, [_c("div", [_vm._v(" " + _vm._s("".concat(_vm.listCountries.find(function (x) {
      return x.id_country == item.countryId;
    }).printable_name)) + " " + _vm._s(item.stateId ? "- ".concat(_vm.listStates.find(function (x) {
      return x.id_state == item.stateId;
    }).state_label) : "") + " ")]), _c("div", {
      staticClass: "flex items-center gap-2"
    }, [_c(VIcon, {
      staticClass: "cursor--pointer fa fa-trash",
      attrs: {
        title: "Remove",
        size: "12"
      },
      on: {
        click: function click($event) {
          return _vm.removeDestination(item);
        }
      }
    })], 1)])]);
  }), 0), !_vm.isAdding ? _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: "",
      disabled: _vm.hasChangedDestinations,
      loading: _vm.syncingStocksIntendedCountries.isPending
    },
    on: {
      click: _vm.confirmSyncStocksIntendedCountries
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-sync mr-1",
    attrs: {
      size: "0.65rem"
    },
    on: {
      click: _vm.confirmSyncStocksIntendedCountries
    }
  }), _vm._v(" " + _vm._s(!_vm.hasChangedDestinations ? "Update intended countries of warehouse's stocks" : "Save modifications before syncing countries") + " ")], 1)], 1) : _vm._e(), _c(VDivider, {
    staticClass: "mt-2 mb-2"
  }), _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v("Add destination")]), _c("div", [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      label: "Country",
      items: _vm.listCountriesForAddDestination,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "printable_name",
      "item-value": "id_country",
      placeholder: "Type a country name"
    },
    on: {
      change: function change($event) {
        return _vm.changeCountry();
      }
    },
    model: {
      value: _vm.formDestination.countryId,
      callback: function callback($$v) {
        _vm.$set(_vm.formDestination, "countryId", $$v);
      },
      expression: "formDestination.countryId"
    }
  })], 1), _vm.displayedStatesList.length > 0 ? _c("div", [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: "State",
      items: _vm.displayedStatesList,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "state_label",
      "item-value": "id_state",
      clearable: ""
    },
    model: {
      value: _vm.formDestination.stateId,
      callback: function callback($$v) {
        _vm.$set(_vm.formDestination, "stateId", $$v);
      },
      expression: "formDestination.stateId"
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "action-add"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      disabled: _vm.isInvalidFormDestination,
      loading: _vm.isAddingDestination
    },
    on: {
      click: function click($event) {
        return _vm.addDestination();
      }
    }
  }, [_vm._v(" Add ")])], 1)], 1)], 1)], 1)], 1), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v("Cancel")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: !(_vm.form.valid && _vm.$refs.address.valid && _vm.$refs.reservation.valid)
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(" Save ")])], 1)], 1), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };